import React from 'react'

import classNames from './RatingPicker.css'
import Icon from '../Icon'

export default function RatingPicker ({ value, onChange, onCancel, updateRating }) {
  const addRating = n => {
    const operator = value.length !== 0 ? value[0].operator : 'should'
    const newValue = value.concat({ value: n, operator })
    onChange(newValue)
    updateRating(newValue)
  }
  const removeRating = n => {
    const newValue = value.filter(r => r.value !== n)
    onChange(newValue)
    updateRating(newValue)
  }
  const stars = []

  const nullSelected = value.findIndex(r => r.value === null) !== -1
  const onClickNull = nullSelected ? () => removeRating(null) : () => addRating(null)
  stars.push(
    <button key='null' onClick={onClickNull} className={nullSelected ? classNames.nullButtonSelected : classNames.nullButton}>
      No rating
    </button>
  )

  for (let i = 1; i <= 5; i++) {
    const selected = value.findIndex(r => r.value === i) !== -1
    const onClick = selected ? () => removeRating(i) : () => addRating(i)
    stars.push(
      <button key={i} onClick={onClick}>
        <Icon
          size={30}
          icon={selected ? 'star' : 'star-outline'}
          className={selected ? classNames.star : classNames.starOutline}
        />
      </button>
    )
  }
  return (
    <div className={classNames.picker}>
      {stars}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/search/RatingPicker.js